import { types } from 'mobx-state-tree';

/**
 * nullable enum factory method
 * @param {*} enumLike enum like object
 * @returns nullable enumeration that defaults to null
 */
const nullableEnum = (enumLike) =>
  types.optional(
    types.maybeNull(types.enumeration(Object.keys(enumLike))),
    null,
  );

export const Layers = {
  filter: 'filter',
  favourites: 'favourites',
  search: 'search',
  info: 'info',
  parking: 'parking',
  myLocations: 'myLocations',
};

export const Modals = {
  addLocationHelp: 'addLocationHelp',
  confirmDelete: 'confirmDelete',
  confirmLocationsDelete: 'confirmLocationsDelete',
  noFavourites: 'noFavourites',
  noLocation: 'noLocation',
  noMyLocations: 'noMyLocations',
  addMyLocations: 'addMyLocations',
};

export const LayerStore = types
  .model({
    activeLayer: nullableEnum(Layers),

    activeModal: nullableEnum(Modals),

    showInfoLayer: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    openLayer: (layer) => {
      if (!Object.keys(Layers).includes(layer))
        throw new Error(`Invalid layer`);
      self.activeLayer = layer;
    },
    closeLayer: () => {
      self.activeLayer = null;
    },

    openModal: (modal) => {
      if (!Object.keys(Modals).includes(modal))
        throw new Error(`Invalid modal`);

      self.activeModal = modal;
    },
    closeModal: () => {
      self.activeModal = null;
    },
  }));
